import React from 'react'
import TestimonialCards from './TestimonialCards'
import Carousels from '../Carousels'
import taijo from '../../assets/testimonials/parent/Teijo.webp'
import trisha from "../../assets/testimonials/parent/trisha.webp"
import haya from "../../assets/testimonials/parent/haya.webp"
import aashwath from "../../assets/testimonials/parent/aashwath.webp"
import Janki from "../../assets/testimonials/parent/janki.webp"
import Kaurs from "../../assets/testimonials/parent/harpret.webp"
import sahid from "../../assets/testimonials/parent/shahid.webp"
import umar from "../../assets/testimonials/parent/umar.webp"
import gursan from "../../assets/testimonials/parent/gurshaan.webp"
import rajat from "../../assets/testimonials/parent/rajat.webp"
import amber from "../../assets/testimonials/parent/amber.webp"
function Testimonials() {
    const data = [
        {
            id: 1,
            name: "Trisha Reddy",
            content: "Nidhi Bhardwaj Ma'am is a wonderful teacher. She's flexible, caring, and truly connects with my child. Great value and teaching quality!",
            subtitle: "(Parent, UK)",
            expriance: "",
            image:trisha    
        },
        {
            id: 2,
            name: "Haya Ayubzai",
            content: "My daughter struggled with her schoolwork until she started classes with Charu Grover and Rekha Chowdhary. Now she participates confidently in school.",
            subtitle: "(Parent, Canada)",
            image:haya
        },
        {
            id: 3,
            name: "Teijo Parthav Maddula",
            content: "Shikha Ma'am is patient, responsive, and kind. She understands my kids and makes learning enjoyable for them. Excellent support team as well!",
            subtitle: "(Parent, Australia)",
            image:taijo
        },
        {
            id: 4,
            name: "Ashvath Kolla",
            content: "Sonali Ma'am is a great motivator. She encourages our son to explore and learn new things. We're truly grateful.",
            subtitle: "(Parent)",
            image:aashwath
        },
        {
            id: 5,
            name: "Janki",
            content: "Ms. Shikha Mutneja teaches so well. My kids enjoy every class and have learned so much—even tricky topics like Rubik's cubes!",
            subtitle: "(Parent)",
            image:Janki
        },
        {
            id: 6,
            name: "Prabhleen & Harkirat Kaur Kahlon",
            content: "The program fully supports my kids' academic needs. What they learn in class really helps at school. We're very happy!",
            subtitle: "(Parents)",
            image : Kaurs
        },
        {
            id: 7,
            name: "Shahid Hussain",
            content: "Teacher Shikha Mutneja makes lessons fun and engaging. My son enjoys reading and is now confident in his writing skills.",
            subtitle: "(Parent)",
            eimage:sahid
        },
        {
            id: 8,
            name: "Umar Farooq",
            content: "Ms. Sonia Sood is excellent, but please explain cultural words (like 'Jahapana') to help international kids follow better.",
            subtitle: "(Parent, Canada)",
            image:umar
        },
        {
            id: 9,
            name: "Gurshaan & Gurnoor Kahlon",
            content: "Shikha is doing a great job. Both my children are meeting their learning milestones. World O' Tutors has exceeded our expectations.",
            subtitle: "(Parents)",
           image: gursan
        },
        {
            id: 10,
            name: "Rajat Malhotra",
            content: "This is by far the best online learning platform. My child has improved public speaking and grown in confidence!",
            subtitle: "(Parent, Australia)",
            image:rajat
        }, 
          {
            id: 11,
            name: " Amber Mann",
            content: "Shikha Ma'am has been amazing! This tutoring has truly helped my child understand math better and improve her grades.",
            subtitle: "(Parent, USA)",
            image:amber
        }
    ]
  return (
    <div className='container mx-auto'>
    <div className='py-5'>
          <h2 className='h1 text-center  max-w-2xl mx-auto'> What Parents Are Saying About World O' Tutors </h2>
    </div>
<div className='pt-4'>
<Carousels >
        {
         data.map((item: any) => (
             <TestimonialCards
                 key={item.id}
                 name={item.name}
                 content={item.content}
                 subtitle={item.subtitle}
                 image = {item.image}
             />
         ))
}
</Carousels>
</div>
    </div>
  )
}

export default Testimonials
